angular.module("componentes").controller("vgrPageCtrl", [
	"$rootScope",
	"$scope",
	"$timeout",
	"permissionService",
	function ($rootScope, $scope, $timeout, permissionService) {
		"use strict";

		$scope.hideMenu = false;

		$scope.isLoading = false;

		$scope.$on(Vgr.constants.evtStartLoadingPage, function () {
			$scope.isLoading = true;
		});

		$scope.$on(Vgr.constants.evtFinishLoadingPage, function () {
			$timeout(function () {
				$scope.isLoading = false;
			});
		});

		$scope.$on(Vgr.constants.evtShowMenu, function (event, data) {
			if (data === false) {
				$scope.hideMenu = true;
			} else {
				$scope.hideMenu = false;
			}
		});

		$scope.getOnlyContent = function () {
			return $rootScope.onlyContent;
		};

		$scope.isIusNatura = Vgr.util.isIusNatura();
		$scope.pageClass = "";

		var refreshSupportWidgetIntervalId = setInterval(refreshSupportWidget, 1000);
		var supportElementId = "ze-snippet";
		var CSNOrganizationId = 22575;

		this.$onInit = function () {
			if ($scope.isIusNatura) {
				$scope.pageClass = "ius-natura";
			}

			refreshSupportWidget();
		};

		this.$onDestroy = function () {
			clearInterval(refreshSupportWidgetIntervalId);
		};

		function refreshSupportWidget() {
			if (showSupportWidget()) {
				createSupportWidget();
			} else {
				removeSupportWidget();
			}
		}

		function showSupportWidget() {
			var currentUrl = window.location.href;
			if (currentUrl.includes("/login")) {
				return true;
			}
			return !permissionService.isMaster() && !permissionService.hasAccessToOrganization(CSNOrganizationId);
		}

		function createSupportWidget() {
			if (document.getElementById(supportElementId)) {
				return;
			}
			var script = document.createElement("script");
			script.id = supportElementId;
			script.src = "https://static.zdassets.com/ekr/snippet.js?key=d30ab299-b3e2-407f-a64b-e89ecdfc3965";
			document.body.appendChild(script);
		}

		function removeSupportWidget() {
			var script = document.getElementById(supportElementId);
			if (script) {
				document.body.removeChild(script);
			}
			var iframe = document.getElementById("launcher");
			if (iframe) {
				iframe.parentNode.removeChild(iframe);
			}
			var closeButton = document.querySelector('button[aria-label="Close message from company"]');
			if (closeButton && closeButton.click) {
				closeButton.click();
			}
		}
	}
]);
